<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from '#imports';

const { list = [], duration = 6000 } = defineProps<{
  list?: any[];
  duration?: number;
}>();

const item = ref();
let index = 0;
let timer: null | number = null;

function init() {
  if (list && list.length) {
    item.value = list[0];

    timer = window.setInterval(() => {
      if (item.value) {
        const len = list.length;
        index = (index + 1) % len;
      } else {
        index = 0;
      }
      item.value = list[index];
    }, duration);
  }
}

function dispose() {
  if (timer) {
    window.clearInterval(timer);
  }
}

onMounted(() => {
  init();
});

onUnmounted(() => {
  dispose();
});
</script>

<template>
  <slot v-if="item" :item="item"></slot>
</template>
